<div class="app-content">
  <router-outlet></router-outlet>
</div>
<lib-alert></lib-alert>
